import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import ToggleButton from "../../components/helpers/ToggleButton";
import { fetchAxiosNoToken } from "../../helpers/fetchAxiosNoToken";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import SpinnerVerifyToken from "../../routes/SpinnerVerifyToken";
import { Capacidad } from "../design1/Design1";
import { ModalChat } from "../modalEdit/ModalChat";
import Mapa from "./Mapa";

import Actividades from "./Actividades";
import Carrousel from "./Carrousel";
import Habitaciones from "./Habitaciones";

import Navbar from "./Navbar/Navbar";
import { PrecioBase } from "./PrecioBase";
import Reservar from "./Reservar";

import Servicios from "./Servicios";
import Imagenes from "./Imagenes";
import Reserva from "./Reserva";
import Reviews from "./Reviews";
import Eventos from "./Eventos";
import { FooterLanding } from "../modalEdit/FooterLanding";
import HabitacionesHotel from "../design1New/HabitacionesHotel";
import ToursHotel from "../design1New/ToursHotel";

const Design4 = (tipo_landing: { tipo_landing: number }) => {
    const [scrollY, setScrollY] = useState(window.scrollY);
    const [toggleButton, setToggleButton] = useState(false);
    //    const { checking } = useAppSelector((state) => state.landing_house.house);
    const casa = useAppSelector((state) => state.landing_house.house);
    const { id, tipo_usuario } = useAppSelector(
        (state) => state.usuario_logeado,
    );

    return (
        <>
            {!casa.banner ? (
                <SpinnerVerifyToken />
            ) : (
                <div>
                    <Navbar />
                    <div className="flex flex-col gap-4 bg-white shadow-lg lg:gap-5 2xl:gap-8">
                        <div id="fotos">
                            <Carrousel
                                tipo_landing={tipo_landing.tipo_landing}
                                toggleButton={toggleButton}
                            />
                        </div>

                        <div className="flex flex-col gap-8 bg-white 2xl:p-4 2xl:py-10 lg:px-16">
                            {(casa.id_propietario === id ||
                                tipo_usuario === 4) && (
                                <div className="flex justify-end w-10/12 mt-3">
                                    <p>
                                        <span className="text-[#053465] font-medium mr-2">
                                            Activar edicion rapida
                                        </span>
                                    </p>
                                    <ToggleButton
                                        isToggled={false}
                                        onChangeToggle={(e) =>
                                            setToggleButton(e)
                                        }
                                    />
                                </div>
                            )}
                        </div>
                        {casa.tipo_calendario === "venta" ||
                        casa.tipo_calendario === "alquiler" ? null : (
                            <div id="reserva">
                                <Reserva
                                    tipo_landing={tipo_landing.tipo_landing}
                                    toggleButton={toggleButton}
                                />
                            </div>
                        )}
                        {tipo_landing.tipo_landing !== 8 &&
                            (casa.tipo_inmueble === "casa" ||
                                casa.tipo_inmueble === "departamento") && (
                                <div
                                    className="bg-[#f2f5ff] "
                                    id="habitaciones"
                                >
                                    <Habitaciones toggleButton={toggleButton} />
                                </div>
                            )}

                        {tipo_landing.tipo_landing === 8 && (
                            <div
                                className="px-4 py-5 bg-white lg:px-16"
                                id="habitaciones"
                            >
                                <HabitacionesHotel
                                    toggleButton={toggleButton}
                                />
                            </div>
                        )}

                        {tipo_landing.tipo_landing === 8 && (
                            <div
                                className="px-4 py-5 bg-white lg:px-16"
                                id="tours"
                            >
                                <ToursHotel toggleButton={toggleButton} />
                            </div>
                        )}
                        {casa.tipo_calendario === "alquiler vacacional" && (
                            <div id="servicios">
                                <Servicios
                                    tipo_landing={tipo_landing.tipo_landing}
                                    toggleButton={toggleButton}
                                />
                            </div>
                        )}

                        <div id="actividades">
                            <Eventos toggleButton={toggleButton} />
                        </div>

                        <div id="resenas">
                            <Reviews toggleButton={toggleButton} />
                        </div>

                        <div className="px-4 lg:px-16" id="ubicacion">
                            <Mapa toggleButton={toggleButton} />
                        </div>
                        <div>
                            <FooterLanding toggleButton={toggleButton} />
                        </div>
                    </div>
                    <ModalChat bg={"bg-black"} />
                </div>
            )}
        </>
    );
};

export default Design4;
